import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SelectInput from '../../../common/inputs/select-input';
import { withEditSpot } from '../../../../../spots/hoc/withEditSpot';

var SortByKeys = {
  BEST: { value: 'best', text: 'Best' },
  NEWEST: { value: 'newest', text: 'Newest' },
  OLEST: { value: 'oldest', text: 'Oldest' }
};

function getSortBy(value) {
  var sortBy = null;
  switch (value) {
    case 'newest':
      sortBy = SortByKeys.NEWEST;
      break;
    case 'oldest':
      sortBy = SortByKeys.OLEST;
      break;
    case 'best':
    default:
      sortBy = SortByKeys.BEST;
      break;
  }
  return sortBy;
}

class SortBy extends Component {
  constructor(props, context) {
    super(props, context);
    var sortBy = getSortBy(props.value);
    this.state = { sortBy };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.value && nextProps.value !== -1) {
      var sortBy = getSortBy(nextProps.value);
      this.setState({ sortBy });
    }
  }

  handleSortByChange(sortBy) {
    this.setState({ sortBy });
    this.props.editSpot(this.props.spotId, { sort_by: sortBy.value });
  }

  render() {
    var value = this.state.sortBy;
    return (
      <div className="platform-selection">
        <SelectInput
          title="Default Sorting"
          description="Set the default sorting of comments in conversations. All sorting options will still be available to your users."
          onChange={this.handleSortByChange.bind(this)}
          options={[SortByKeys.NEWEST, SortByKeys.BEST, SortByKeys.OLEST]}
          value={value}
        />
      </div>
    );
  }
}

SortBy.propTypes = {
  value: PropTypes.oneOf(['newest', 'best', 'oldest']),
  spotId: PropTypes.string
};

SortBy.displayName = 'SortBy';

export default withEditSpot(SortBy);
